import mensagemService from '../Services/Mensagem.service'
import eventBus from './event.bus'

export const EVENTO_CONTAGENS_NOTIFICACAO = 'MensagensNotificacao'

const DADOS_VERIFICACAO_NOTIFICACAO_KEY = 'dadosVerificacaoNotificacao'
const INTERVALO_VERIFICACAO_NOTIFICACAO = 15 * 60 * 1000 // 15 minutos

let requisicaoContagensNaoLidasEmAndamento = null
let ultimaContagemPublicada = null

function normalizarContagens(mensagens, notificacoes) {
  return {
    mensagens: parseInt(mensagens, 10) || 0,
    notificacoes: parseInt(notificacoes, 10) || 0,
  }
}

export function notificarContagensAtualizadas(mensagens, notificacoes, { forcar = false } = {}) {
  const contagens = normalizarContagens(mensagens, notificacoes)
  if (
    !forcar
    && ultimaContagemPublicada
    && ultimaContagemPublicada.mensagens === contagens.mensagens
    && ultimaContagemPublicada.notificacoes === contagens.notificacoes
  ) {
    return contagens
  }

  ultimaContagemPublicada = contagens
  eventBus.dispatchEvent(new CustomEvent(EVENTO_CONTAGENS_NOTIFICACAO, {
    detail: { ...contagens },
  }))
  return contagens
}

function lerNotificacoesCache() {
  try {
    const raw = localStorage.getItem(DADOS_VERIFICACAO_NOTIFICACAO_KEY)
    if (!raw) return null

    const dados = JSON.parse(raw)
    if (
      typeof dados?.timestamp !== 'number' ||
      typeof dados?.mensagens !== 'number' ||
      typeof dados?.notificacoes !== 'number'
    ) {
      return null
    }

    return dados
  } catch {
    return null
  }
}

function salvarNotificacoesCache(mensagens, notificacoes, timestamp = Date.now()) {
  localStorage.setItem(DADOS_VERIFICACAO_NOTIFICACAO_KEY, JSON.stringify({
    timestamp,
    mensagens,
    notificacoes,
  }))
}

export function limparSessaoNotificacoes() {
  ultimaContagemPublicada = null
  requisicaoContagensNaoLidasEmAndamento = null
  try {
    localStorage.removeItem(DADOS_VERIFICACAO_NOTIFICACAO_KEY)
  } catch {
    // ignore
  }
}

function agendarAtualizacaoProximoMinuto() {
  void obterContagensNaoLidas({ forcar: true })
}

function contagensDoCache(cache) {
  return {
    mensagens: cache.mensagens,
    notificacoes: cache.notificacoes,
  }
}

async function buscarContagensNaoLidasNaApi() {
  const agora = Date.now()

  try {
    const result = await mensagemService.getNotificacaoNaoLidas()
    if (result.Success) {
      const mensagens = parseInt(result.Data.mensagens, 10) || 0
      const notificacoes = parseInt(result.Data.notificacoes, 10) || 0
      salvarNotificacoesCache(mensagens, notificacoes, agora)
      return { mensagens, notificacoes }
    }
  } catch {
    // fallback cache abaixo
  }

  const cache = lerNotificacoesCache()
  if (cache)
    return contagensDoCache(cache)

  return { mensagens: 0, notificacoes: 0 }
}

async function obterContagensNaoLidas({ forcar = false } = {}) {
  const agora = Date.now()
  const cache = lerNotificacoesCache()

  let contagens

  if (!forcar && cache && agora - cache.timestamp < INTERVALO_VERIFICACAO_NOTIFICACAO)
    contagens = contagensDoCache(cache)
  else if (requisicaoContagensNaoLidasEmAndamento)
    contagens = await requisicaoContagensNaoLidasEmAndamento
  else {
    requisicaoContagensNaoLidasEmAndamento = buscarContagensNaoLidasNaApi()
      .finally(() => {
        requisicaoContagensNaoLidasEmAndamento = null
      })
    contagens = await requisicaoContagensNaoLidasEmAndamento
  }

  notificarContagensAtualizadas(contagens.mensagens, contagens.notificacoes, { forcar })
  return contagens
}

export default {
  DADOS_VERIFICACAO_NOTIFICACAO_KEY,
  EVENTO_CONTAGENS_NOTIFICACAO,
  INTERVALO_VERIFICACAO_NOTIFICACAO,
  lerNotificacoesCache,
  salvarNotificacoesCache,
  agendarAtualizacaoProximoMinuto,
  limparSessaoNotificacoes,
  notificarContagensAtualizadas,
  obterContagensNaoLidas,
}
